import { useMask } from "@react-input/mask";
import { useState } from "react";
import { Tab } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { StylesConfig } from "react-select";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../Airoom.css';
import Ribbon from "../../../core/common/ribbon/ribbon";
import { organizationData } from "../../../core/data/json/organizationData";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import TasksImportant from "../../crm/task/tasksImportant";
import { all_routes } from "../../router/all_routes";
import LeadNotes from "./LeadNotes/LeadNotes";
import LeadUserTask from "./LeadTasks/LeadUserTasks";
import LeadsUserDetail from "./LeadsUserDetail";
import Assignments from "../ProjectTabs/ProjectAssignments/Assignments";
import ClientVisit from "../ProjectTabs/ClientVisit/ClientVisit";
import Documents from "../ProjectTabs/Documents/Documents";
import Meetings from "../ProjectTabs/Meetings/Meetings";
import LeadContacts from "./LeadContacts/LeadContacts";
import OpportunityDetails from "./OpportunityDetails/OpportunityDetails";

const route = all_routes;

const LeadsUserDetails = () => {
  const [adduser, setAdduser] = useState(false);
  const [modalTitle, setModalTitle] = useState("New Organization");
  const [buttonTitle, setButtonTitle] = useState("Save");
  const [showModalform, setShowModalform] = useState(false);
  const [showModalformPreview, setShowModalformPreview] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);



  const data = organizationData;
  const navigate = useNavigate();
  const notify = () => toast("Wow so easy!");

  const location = useLocation();
  // const path = location.pathname;
  // const isReadOnly = location.pathname.includes('leadsUserDetails');

  



  const actionbutton = location.pathname.includes('editLead') ? 'Update' : 'Save';
  // const pageTitle= location.pathname.includes('editLead') ?'Update'||location.pathname.includes('editLead') ?'Update'||location.pathname.includes('editLead') ?'New';


  const handleBack = () => {
    navigate('/leads')
  }


  const items = [
    {
      icon: svgIcons.BackIcon, onClick: handleBack,
    },

    // { label: "Edit", icon: svgIcons.updateIcon, hidden: location.pathname.includes('leadsUserDetails') || location.pathname.includes('addLead') },
  ];


  //Stepper code functionality//



  return (
    <>

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <Ribbon
                items={items}
              />
              {/* /Page Header */}
              <Tab.Container id="left-tabs-example" defaultActiveKey="details">
                <Row>
                  <Col sm={12}>
                    <div className="card main-card">
                      <div className="card-body">
                        {location.pathname.includes('leadsUserDetails') || location.pathname.includes('editLead') ? (
                          <>
                            <h4 className="color-red mb-3">
                              Lead-L031232
                            </h4>
                            <p>Renovation of House no. 188</p>
                          </>
                        ) : (
                          <h4 className="color-red mb-3">
                            New Lead
                          </h4>
                        )}
                        <Nav className="flex l-tabs">
                          <Nav.Item>
                            <Nav.Link className="nav-tabs" eventKey="details" >Details</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="contacts">Contacts</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="tasks">Tasks</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="opportunitydetails">Opportunity Details</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="assignments">Assignments</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="clientvisits">Client Visits</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="notes">Notes</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="documents">Documents</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="propertyresources">Property Resources</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="projectprogress">Project Progress</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="meetings">Meetings</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="printouts">Printouts</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link  className="nav-tabs" eventKey="metrics">Metrics</Nav.Link>
                          </Nav.Item>
                        </Nav>
                      </div>
                    </div>
                  </Col>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="details" >
                       <LeadsUserDetail  />
                      </Tab.Pane>
                      <Tab.Pane eventKey="contacts" >
                       <LeadContacts  />
                      </Tab.Pane>
                      <Tab.Pane eventKey="tasks"> 
                          <LeadUserTask/>
                      </Tab.Pane>
                      <Tab.Pane eventKey="notes">
                       <LeadNotes />
                      </Tab.Pane>
                      <Tab.Pane eventKey="assignments">
                       <Assignments />
                      </Tab.Pane>
                      <Tab.Pane eventKey="clientvisits">
                       <ClientVisit />
                      </Tab.Pane>
                      <Tab.Pane eventKey="documents">
                       <Documents />
                      </Tab.Pane>
                      <Tab.Pane eventKey="meetings">
                       <Meetings />
                      </Tab.Pane>
                      {/* <Tab.Pane eventKey="opportunitydetails">
                       <OpportunityDetails />
                      </Tab.Pane> */}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadsUserDetails;
